(function () {
    var topicalAlerts = {
        init: function () {
            topicalAlerts.initOnClickTagsHandlers();
            topicalAlerts.initSaveOnClickHandler();
            topicalAlerts.setExpandLinkOnClickEvent();
            topicalAlerts.moveToFocusedElement();
            topicalAlerts.highLightTopicalJournal(false);
            topicalAlerts.addCloseClickHandler();
        },

        initOnClickTagsHandlers: function () {
            var $topicalContainer = $('.topical-alerts-container');
            var $links;
            var i;
            var $tagLink;

            if ($topicalContainer.length === 0) {
                return;
            }

            $links = $topicalContainer.find('.tagLink');

            for (i = 0; i < $links.length; i++) {
                $tagLink = $($links[i]);
                $tagLink.unbind('click');
                $tagLink.on('click', topicalAlerts.clickTagHandler);
            }
        },

        clickTagHandler: function (event) {
            var element = $(event.target).parent();
            var $link = $(element);
            var $tag;
            var tagUri;
            var $container = $link.closest('.browse-taxonomies');
            var $topicalContainer = $link.closest('.topical-alerts-container');
            var tagLabel;
            var $tagGroup;
            var level;

            if ($link.length <= 0) {
                return;
            }

            $tag = $($link.closest('.tag')[0]);
            tagUri = $tag.attr('tagUri');

            if ($tag.hasClass('selected')) {
                // Already selected, do nothing.
            } else {
                tagLabel = $link.find('span').text();
                $tagGroup = $link.closest('.tagGroup');
                level = $tagGroup.attr('level');

                $container.append(
                    '<input class="conceptsIDs" type="hidden" value="' +
                        tagUri +
                        '" tagLabel="' +
                        tagLabel +
                        '" level="' +
                        level +
                        '">'
                );

                topicalAlerts.selectCurrentTagAndDeselectParents($tag, $container);
                topicalAlerts.deselectTopicalChildren($tag, $container);
                topicalAlerts.reDrawSelectedTags($container);
                topicalAlerts.updateCounters($topicalContainer);
            }
        },

        /**
         * This method adds class 'selected' to elements: classed with 'tag' and 'tagName'.
         * So we deal with both of them.
         * Also it removes the hidden element which holds the tag uri.
         */
        selectCurrentTagAndDeselectParents: function (tag, container) {
            var $tag = $(tag);
            var $container = $(container);
            var $tagName = $($tag.find('.tagName')[0]);
            var $selectedParents;
            var i;
            var $parent;
            var parentTagName;

            $tag.addClass('selected');
            $tagName.addClass('selected');
            $selectedParents = $tag.parents('.tag.selected');

            for (i = 0; i < $selectedParents.length; i++) {
                $parent = $($selectedParents[i]);
                $parent.removeClass('selected');

                parentTagName = $($parent.find('.tagName')[0]);
                parentTagName.removeClass('selected');

                $container.find(".conceptsIDs[value='" + $parent.attr('tagUri') + "']").remove();
            }
        },

        /**
         * This method removes 'selected' class from elements classed with 'tag' and 'tagName'.
         * Also it removes the hidden element which holds the tag uri.
         */
        deselectTopicalChildren: function (tag, container) {
            var $tag = $(tag);
            var $container = $(container);
            var $selectedChildren = $tag.find('.tag.selected');
            var i;
            var $childTag;
            var $childTagName;

            for (i = 0; i < $selectedChildren.length; i++) {
                $childTag = $($selectedChildren[i]);
                $childTag.removeClass('selected');
                $childTagName = $($childTag.find('.tagName')[0]);
                $childTagName.removeClass('selected');

                $container.find(".conceptsIDs[value='" + $childTag.attr('tagUri') + "']").remove();
            }
        },

        /**
         * Re-draw the selected tags by clearing the '.selected-tags' div, and redrawing its content.
         */
        reDrawSelectedTags: function () {
            var $container = $('.topical-alerts-container');
            var $concepts = $container.find(".conceptsIDs[type='hidden']");
            var $selectedTagsSection = $container.find('.selected-tags');
            var $concept;
            var tagUri;
            var tagLabel;

            $selectedTagsSection.empty();

            $.each($concepts, function (index, value) {
                $concept = $($concepts[index]);
                tagUri = $concept.val();
                tagLabel = $concept.attr('tagLabel');

                $selectedTagsSection.append(
                    '<div class="filter-wrapper" tagUri="' +
                        tagUri +
                        '">' +
                        '<div class="topical-alert-filter">' +
                        '<span>' +
                        tagLabel +
                        '</span>' +
                        '<div class="close" onclick="removeTopicalFilter(\'' +
                        tagUri +
                        '\', true)"></div>' +
                        '</div>'
                );

                if (index !== $concepts.length - 1) {
                    $selectedTagsSection.append('<div class="separator">, </div>');
                }

                $selectedTagsSection.append('</div>');
            });

            if ($concepts.length === 0) {
                changeCounterLineToDefault();
            }
        },

        changeCounterLineToDefault: function () {
            var $container = $('.topical-alerts-container');

            var $counterLine = $container.find('.counter-line');
            var $allArticlesCount = $container.find('.all-articles-count');
            var articlesCount = 0;

            if ($allArticlesCount.length !== 0) {
                articlesCount = $allArticlesCount.val();
            }

            $counterLine.html(
                'Articles that match your criteria: <span class="bold-counter all-articles-counter">' +
                    articlesCount +
                    '</span>. Select a term to narrow your results.'
            );
        },

        /**
         * Removes class 'selected' from elements classed with 'tag' and 'tagName', it
         * removes class of them if and only if they are classed with 'selected'.
         *
         * Then it re-draw the selected tags section.
         *
         * @param tagUri
         */
        removeTopicalFilter: function (tagUri, doUpdateCounters) {
            var $container = $('.topical-alerts-container');
            var $conceptID = $container.find(".conceptsIDs[type='hidden'][value='" + tagUri + "']");
            var $selectedTag = $container.find('.tag.selected[tagUri="' + tagUri + '"]');
            var $childTagName;

            if (tagUri === '' || tagUri === undefined) {
                return;
            }

            if ($conceptID.length !== 0) {
                $conceptID.remove();
            }

            if ($selectedTag.length !== 0) {
                $selectedTag.removeClass('selected');

                $childTagName = $($selectedTag.find('.tagName')[0]);
                $childTagName.removeClass('selected');
            }

            topicalAlerts.reDrawSelectedTags($container);

            if (doUpdateCounters === true) {
                topicalAlerts.updateCounters($container);
            }
        },

        initSaveOnClickHandler: function () {
            var $saveBtn = $('.topical-alerts-container .save-btn');

            if ($saveBtn.length === 0) {
                return;
            }

            $saveBtn.unbind();
            $saveBtn.on('click', topicalAlerts.saveTopicalAlertsWidget);
        },

        saveTopicalAlertsWidget: function (event) {
            var $container = $('.topical-alerts-container');

            var $table = $('#journalsAlertsTable tbody');
            var jourCode = $container.find('.journalCode').val();
            var jourName = $('#journal-' + jourCode).html();
            var pubID = $container.find('.JourPubID').val();
            var excludedJournalCodes = $('#journalCodes').val();
            var $iipDefaultFrequencyInput = $container.find('.iip-default-frequency');
            var iipDefaultFreq = $iipDefaultFrequencyInput.length > 0 ? $iipDefaultFrequencyInput.val() : 'N';
            var $showIssueAlertCheckBox = $container.find('.show-issue-alert-check-box');
            var $hideArticleAlertsFrequency = $container.find('.hide-article-alerts-frequency');
            var showTocCheckbox = $showIssueAlertCheckBox.val() === 'true';
            var i;
            var $concepts = $container.find(".conceptsIDs[type='hidden']");
            var conceptsMarkup = '';
            var $existedTopicalAlert = $table.find('#added-journal-' + jourCode);
            var tocCheckbox = '';
            var asapIIPFrequency = '';
            var $journalCheckbox;
            var $concept, tagLabel, tagLevel;
            var $parentLi;
            var $jourLink;
            var newTopicalAlertData;
            var topicalAlertName;
            var alertPreviouslyExists;

            if (excludedJournalCodes !== '') {
                excludedJournalCodes = excludedJournalCodes.split(',');
                for (i = 0; i < excludedJournalCodes.length; i++) {
                    if (excludedJournalCodes[i] === jourCode) {
                        showTocCheckbox = false;
                    }
                }
            }

            if ($concepts.length === 0) {
                if ($existedTopicalAlert.length > 0) {
                    alert('An alert with the same terms you selected already exists');
                    return;
                }

                if (showTocCheckbox) {
                    tocCheckbox =
                        '<input type="checkbox" id="toc-' +
                        jourCode +
                        '" class="checkbox" checked="checked" value="true" name="toc-' +
                        pubID +
                        '">';
                } else {
                    tocCheckbox =
                        '<input type="checkbox" id="toc-' +
                        jourCode +
                        '" class="checkbox hide" value="false" name="toc-' +
                        pubID +
                        '" disabled>';
                }

                if ($hideArticleAlertsFrequency.val() === 'true') {
                    asapIIPFrequency =
                        '<div class="settingInput hide">' +
                        '<select id="toc-asap-' +
                        jourCode +
                        '" class="dropDownList" name="toc-asap-iip-' +
                        pubID +
                        '">' +
                        '    <option value="N" selected>Never</option>' +
                        '    <option value="D">Daily</option>' +
                        '    <option value="W">Weekly</option>' +
                        '    <option value="M">Monthly</option>' +
                        '</select>';
                    ('</div>');
                } else {
                    asapIIPFrequency =
                        '<div class="settingInput">' +
                        '<select id="toc-asap-' +
                        jourCode +
                        '" class="dropDownList" name="toc-asap-iip-' +
                        pubID +
                        '">' +
                        '    <option value="N" ' +
                        (iipDefaultFreq === 'N' ? 'selected' : '') +
                        '>Never</option>' +
                        '    <option value="D" ' +
                        (iipDefaultFreq === 'D' ? 'selected' : '') +
                        '>Daily</option>' +
                        '    <option value="W" ' +
                        (iipDefaultFreq === 'W' ? 'selected' : '') +
                        '>Weekly</option>' +
                        '    <option value="M" ' +
                        (iipDefaultFreq === 'M' ? 'selected' : '') +
                        '>Monthly</option>' +
                        '</select>' +
                        '</div>';
                }

                $table.append(
                    '<tr id="added-journal-' +
                        jourCode +
                        '">' +
                        '<td class="rowText journalTitle">' +
                        jourName +
                        '</td>' +
                        '<td class="rowText">' +
                        '<div class="settingInput">' +
                        tocCheckbox +
                        '</div>' +
                        '</td>' +
                        '<td class="rowText">' +
                        asapIIPFrequency +
                        '</td>' +
                        '</tr>'
                );

                // Below code is used to check the hidden journal's checkbox, it also wraps the journal link with class 'journal-added'.
                $journalCheckbox = $(
                    '.journalsModalWrap #jmodal-az-layer input[type="checkbox"][name="jcatID"][value="' + pubID + '"]'
                );

                if ($journalCheckbox.length > 0) {
                    $journalCheckbox.prop('checked', 'true');

                    $parentLi = $journalCheckbox.closest('li');
                    $jourLink = $parentLi.find('#journal-' + jourCode);

                    if ($jourLink.length > 0) {
                        if ($jourLink.parents('.journal-added').length === 0) {
                            $jourLink.wrap("<div class='journal-added'></div>");
                        }
                    }
                }
            } else {
                $.each($concepts, function (index, value) {
                    $concept = $(value);
                    tagLabel = $concept.attr('taglabel');
                    tagLevel = $concept.attr('level');

                    conceptsMarkup +=
                        '<div class="leveled-concept">' +
                        '<span class="level-icon" level="' +
                        tagLevel +
                        '"></span>' +
                        '<span class="topical-tag">' +
                        tagLabel +
                        '</span>' +
                        '</div>';
                });

                newTopicalAlertData = topicalAlerts.generateTopicalAlertData(jourCode, $concepts);
                topicalAlertName = topicalAlerts.generateTopicalAlertName(jourCode, $concepts);

                if (topicalAlertName.length > 234) {
                    // max size allowed in DB is 256, but there is a constant that get added to it and its length is 22, so in total 256 - 22 = 234.

                    alert('You have selected a too many terms, please select a less number of terms');
                    return;
                }

                alertPreviouslyExists = topicalAlerts.alertAlreadyExists($table, newTopicalAlertData, jourCode);

                if (alertPreviouslyExists) {
                    alert('An alert with the same terms you selected already exists');
                    return;
                }

                $table.append(
                    '<tr id="' +
                        newTopicalAlertData +
                        '" class="topical_alert topical-saved-search-alert" queryInfoName="' +
                        newTopicalAlertData +
                        '">' +
                        '<td class="rowText journalTitle" colspan="2">' +
                        jourName +
                        '<input type="hidden" name="newTopicalAlert" value="' +
                        newTopicalAlertData +
                        '" />' +
                        '<div>' +
                        conceptsMarkup +
                        '</div>' +
                        '</td>' +
                        '' +
                        '<td class="rowText">' +
                        '<div class="settingInput">' +
                        '<select id="toc-asap-iip-' +
                        jourCode +
                        '" name="frequency-' +
                        newTopicalAlertData +
                        '" class="dropDownList">' +
                        '    <option value="N" ' +
                        (iipDefaultFreq === 'N' ? 'selected' : '') +
                        '>Never</option>' +
                        '    <option value="D" ' +
                        (iipDefaultFreq === 'D' ? 'selected' : '') +
                        '>Daily</option>' +
                        '    <option value="W" ' +
                        (iipDefaultFreq === 'W' ? 'selected' : '') +
                        '>Weekly</option>' +
                        '    <option value="M" ' +
                        (iipDefaultFreq === 'M' ? 'selected' : '') +
                        '>Monthly</option>' +
                        '</select>' +
                        '</div>' +
                        '</td>' +
                        '</tr>'
                );
            }

            topicalAlerts.removeDefaultTabletRecord();
            topicalAlerts.highLightTopicalJournal(true);

            $('#jmodal-close_btn').trigger('click');

            $concepts.remove();
            topicalAlerts.deselectAllTags();
        },

        removeDefaultTabletRecord: function () {
            var $table = $('#journalsAlertsTable tbody');
            var $noJournalsRecord = $table.find('tr#nojournals');

            if ($noJournalsRecord.length > 0) {
                $('#nojournals').hide();
            }
        },

        generateTopicalAlertData: function (jourCode, concepts) {
            var $selectedElements = $(concepts);
            var levelsByConcepts = new Map();

            $.each($selectedElements, function (i, value) {
                var $conceptElement = $(value);
                var level = $conceptElement.attr('level');
                var uri = $conceptElement.val();

                levelsByConcepts.set(uri, level);
            });

            return topicalAlerts.generateSaveSearchName(jourCode, levelsByConcepts);
        },

        generateTopicalAlertName: function (jourCode, concepts) {
            var SEPARATOR = '#';

            var alertName = '';
            var $selectedElements = $(concepts);

            alertName += 'TA#' + SEPARATOR + jourCode + SEPARATOR;

            $.each($selectedElements, function (i, value) {
                var $conceptElement = $(value);

                var uri = $conceptElement.val();
                alertName += uri;
            });

            return alertName;
        },

        deselectAllTags: function () {
            var $container = $('.topical-alerts-container');

            var $allSelectedTagsAndNames = $container.find(
                '.browse-taxonomies-container .tag.selected, .browse-taxonomies-container .tagName.selected'
            );
            var $selectedTagsSection = $container.find('.selected-tags');

            $.each($allSelectedTagsAndNames, function (index, value) {
                $(value).removeClass('selected');
            });

            $selectedTagsSection.html('');
        },

        generateSaveSearchName: function (journalCode, levelsByConcepts) {
            var SEPARATOR = '#'; // Separates between parts of data saved in the Saved Search Name.
            var LEVEL_SEPARATOR = '@'; // Separates between conceptID and its level.
            var CONCEPTS_SEPARATOR = ','; // Separator between concepts.

            var saveSearchName = 'TA#' + SEPARATOR + journalCode + SEPARATOR;

            levelsByConcepts.forEach(function (item, key, map) {
                saveSearchName += key + LEVEL_SEPARATOR + item + CONCEPTS_SEPARATOR;
            });

            if (levelsByConcepts.size > 0) {
                saveSearchName = saveSearchName.substring(0, saveSearchName.length - 1); // remove last comma.
            }

            return saveSearchName;
        },

        calculateCounts: function (link) {},

        setExpandLinkOnClickEvent: function () {
            var $expandServiceUrl = $('.topical-alerts-container .expandServiceUrl');

            if ($expandServiceUrl.length === 0) {
                return;
            }

            $.each($expandServiceUrl, function (index, value) {
                var $serviceUrl = $(value);

                $serviceUrl.attr('value', '/pb/widgets/topicalAlerts/getTagChildren/');
            });
        },

        moveToFocusedElement: function () {
            var $focusedElements = $('#journalsAlertsTable .focused');
            var focusedElement;

            if ($focusedElements.length === 0) {
                return;
            }

            focusedElement = $focusedElements[0];

            $('html, body').animate(
                {
                    scrollTop: $(focusedElement).offset().top - 50,
                },
                2000
            );
        },

        /**
         * Highlights topical journal if at least one alert is assigned to this journal.
         *
         * It searches for any tr which has the attribute 'queryinfoname' starts with 'TOPICAL_LAERTS###' followed by journal code.
         */
        highLightTopicalJournal: function (forceHighlight) {
            var jourCode = $('.topical-alerts-container .journalCode').val();
            var $topicalAlerts = $('tr.topical-saved-search-alert[queryinfoname^="TA##' + jourCode + '"]');
            var $jourLink = $('#jmodal-az-layer a#journal-' + jourCode);
            var $parentDiv = $jourLink.parent('.journal-added');

            if (!forceHighlight) {
                if ($topicalAlerts.length === 0) {
                    return;
                }
            }

            if ($parentDiv.length === 0) {
                $jourLink.wrap("<div class='journal-added'></div>");
            }
        },

        addCloseClickHandler: function () {
            var $topicalContainer = $('.topical-alerts-container');
            var $closeBtn = $('#jmodal-close_btn');

            if ($topicalContainer.length === 0) {
                return;
            }

            if ($closeBtn.length === 0) {
                return;
            }

            $closeBtn.on('click', function (evt) {
                var $allTags = $topicalContainer.find('.tag');
                var i;
                var $tag;
                var tagUri;
                var $tagGroups;
                var $collapseLink = $tag.find('.nav-icon.collapsible');
                var $expandLink = $tag.find('.nav-icon.expandable');

                for (i = 0; i < $allTags.length; i++) {
                    $tag = $($allTags[i]);

                    if ($tag.hasClass('selected')) {
                        tagUri = $tag.attr('taguri');
                        topicalAlerts.removeTopicalFilter(tagUri, false);
                    }

                    $tagGroups = $tag.find('.tagGroup');
                    $.each($tagGroups, function (index, value) {
                        $(value).remove();
                    });

                    if ($collapseLink.length > 0) {
                        $collapseLink.addClass('hidden');
                    }

                    if ($expandLink.length > 0) {
                        $expandLink.removeClass('hidden');
                    }
                }

                topicalAlerts.changeCounterLineToDefault();
            });
        },

        updateCounters: function (topicalContainer) {
            var $container = $(topicalContainer);
            var $selectedTags;
            var conceptsIdsArray;
            var conceptsString;
            var taxCode = $('.taxonomyCode').val();
            var data;
            var journalCode = $container.find('.journalCode').val();
            var $loaderWrap = $container.find('.loader-wrap');
            var $isSynchronousField = $container.find('.is-synchronous-counter-update');
            var isSynchronous = false;

            if ($container.length === 0) {
                return;
            }

            $selectedTags = $container.find('.conceptsIDs');
            conceptsIdsArray = new Array();
            /* eslint-disable */
            conceptsString = '';
            /* eslint-enable */

            if ($selectedTags.length === 0) {
                // if no tags selected then no need to calculate counts.
                return;
            }

            $.each($selectedTags, function (i, value) {
                var $conceptElement = $(value);
                var uri = $conceptElement.val();

                conceptsIdsArray[i] = uri;
                conceptsString += '&ConceptID=' + uri;
            });

            data = {
                ConceptID: conceptsIdsArray,
                taxonomyCode: taxCode,
            };

            $loaderWrap.empty();
            $loaderWrap.append('<img class="loader" src="/templates/jsp/_style2/_achs/images/loading.gif">');

            topicalAlerts.addCalculatingLabel($container);

            if ($isSynchronousField.length === 0) {
                isSynchronous = false;
            } else {
                isSynchronous = $isSynchronousField.val();
            }

            setTimeout(function () {
                /* This delay is added to provide time to update the ui parts which we have modified above (loading image, calculating labels...etc)
                 * before starting the ajax request.
                 */

                $.ajax({
                    async: isSynchronous === 'false',
                    type: 'POST',
                    url: '/pb/widgets/topicalAlerts/getSelectedTagsCounts/' + journalCode,
                    data: data,
                    success: function (data) {
                        var obj = $.parseJSON(data);
                        var numOfArticles = obj.numOfArticles;
                        var lastMonthNumOfArticles = obj.lastMonthNumOfArticles;

                        var counterLine = $container.find('.status-line .counter-line');
                        counterLine.html(
                            'Articles that match your criteria: <span class="bold-counter all-articles-counter">' +
                                numOfArticles +
                                '</span>. ' +
                                'Matches in the last month: <span class="bold-counter last-month-counter">' +
                                lastMonthNumOfArticles +
                                '</span>'
                        );

                        $loaderWrap.find('.loader').remove();
                    },
                    error: function (data) {
                        var $errors = $container.find('.errors');

                        $errors.empty();
                        $errors.append(data);
                    },
                });
            }, 120);
        },

        addCalculatingLabel: function ($container) {
            var $allArticlesCounter = $container.find('.all-articles-counter');
            var $lastMonthCounter = $container.find('.last-month-counter');

            if ($allArticlesCounter.length !== 0) {
                $allArticlesCounter.html('calculating');
                $allArticlesCounter.addClass('on-load-counter');
            }

            if ($lastMonthCounter.length !== 0) {
                $lastMonthCounter.html('calculating');
                $lastMonthCounter.addClass('on-load-counter');
            }
        },

        alertAlreadyExists: function (table, newAlertData, jorCode) {
            var alertExistsWithSameTagsOrder = $(table).find(
                '.topical-saved-search-alert[queryInfoName="' + newAlertData + '"]'
            );
            var newAlertConcepts = newAlertData.replace('TA##' + jorCode + '#', '');
            var newAlert_LeveledConcepts = newAlertConcepts.split(',');
            var $parentTable = $(table);
            var $topicalAlerts = $parentTable.find('.topical-saved-search-alert');
            var alreadyExists = false;

            if (alertExistsWithSameTagsOrder.length > 0) {
                return true;
            }

            newAlert_LeveledConcepts = newAlert_LeveledConcepts.sort();

            if ($topicalAlerts.length === 0) {
                return false;
            }

            $.each($topicalAlerts, function (index, value) {
                var $alertTableRow = $(value);
                var alertData = $alertTableRow.attr('queryinfoname');
                var areEqual;
                var existedAlertConcepts = alertData.replace('TA##' + jorCode + '#', '');
                var existedAlert_LeveledConcepts = existedAlertConcepts.split(',');
                existedAlert_LeveledConcepts = existedAlert_LeveledConcepts.sort();

                areEqual = topicalAlerts.areEqualArrays(newAlert_LeveledConcepts, existedAlert_LeveledConcepts);

                if (areEqual) {
                    alreadyExists = true;
                    return false; // Break loop
                }
            });

            return alreadyExists;
        },

        areEqualArrays: function (arr1, arr2) {
            var i;
            if (arr1.length !== arr2.length) {
                return false;
            }

            for (i = arr1.length; i--; ) {
                if (arr1[i] !== arr2[i]) {
                    return false;
                }
            }

            return true;
        },
    };

    UX.topicalAlerts = topicalAlerts;
})();
